import { useState } from 'react';
import Button from 'src/components/buttons/button';
import BulletedList from 'src/components/bulletedList';
import config from 'config/config';

const PROGRAM_URL = `${config.cdn.navigator}lower-your-cholesterol/`;

function SignupForm() {
  const [hasConsented, setHasConsented] = useState(false);

  const onConsentSelected = e => setHasConsented(e.target.checked === true);

  return (
    <div className="navigator">
      <div className="navigator__sign-up">
        <h2 className="navigator__title" id="subscribe">
          Subscribe
        </h2>
        <div id="mc_embed_signup">
          <form
            action="https://healthunlocked.us6.list-manage.com/subscribe/post?u=b9a5271af1d327e632c3cd503&amp;id=2e984d65aa"
            className="validate"
            id="mc-embedded-subscribe-form"
            method="post"
            name="mc-embedded-subscribe-form"
            noValidate={true}
            target="_blank"
          >
            <div id="mc_embed_signup_scroll">
              <div className="indicates-required">
                <span className="asterisk">*</span> indicates required
              </div>
              <div className="mc-field-group">
                <label className="title" htmlFor="mce-EMAIL">
                  Email Address <span className="asterisk">*</span>
                </label>
                <input
                  className="required email"
                  id="mce-EMAIL"
                  name="EMAIL"
                  type="email"
                />
              </div>
              <div className="mc-field-group input-group">
                <div className="title">What is your age?</div>
                <ul>
                  <li>
                    <input
                      id="mce-K1-0"
                      name="K1"
                      type="radio"
                      value="v1"
                    />
                    <label htmlFor="mce-K1-0">Under 30 years</label>
                  </li>
                  <li>
                    <input
                      id="mce-K1-1"
                      name="K1"
                      type="radio"
                      value="v2"
                    />
                    <label htmlFor="mce-K1-1">30-55 years</label>
                  </li>
                  <li>
                    <input
                      id="mce-K1-2"
                      name="K1"
                      type="radio"
                      value="v3"
                    />
                    <label htmlFor="mce-K1-2">Over 55 years</label>
                  </li>
                </ul>
              </div>
              <div className="mc-field-group input-group">
                <div className="title">What is your ethnicity?</div>
                <ul>
                  <li>
                    <input
                      id="mce-K2-0"
                      name="K2"
                      type="radio"
                      value="v1"
                    />
                    <label htmlFor="mce-K2-0">White</label>
                  </li>
                  <li>
                    <input
                      id="mce-K2-1"
                      name="K2"
                      type="radio"
                      value="v2"
                    />
                    <label htmlFor="mce-K2-1">Black / African / Caribbean / Black British African</label>
                  </li>
                  <li>
                    <input
                      id="mce-K2-2"
                      name="K2"
                      type="radio"
                      value="v3"
                    />
                    <label htmlFor="mce-K2-2">Asian / Asian British</label>
                  </li>
                  <li>
                    <input
                      id="mce-K2-3"
                      name="K2"
                      type="radio"
                      value="v4"
                    />
                    <label htmlFor="mce-K2-3">Mixed / multiple ethnic groups</label>
                  </li>
                  <li>
                    <input
                      id="mce-K2-4"
                      name="K2"
                      type="radio"
                      value="v5"
                    />
                    <label htmlFor="mce-K2-4">Other ethnic group</label>
                  </li>
                </ul>
              </div>
              <div className="mc-field-group input-group">
                <div className="title">Do you smoke?</div>
                <ul>
                  <li>
                    <input
                      id="mce-K3-0"
                      name="K3"
                      type="radio"
                      value="v1"
                    />
                    <label htmlFor="mce-K3-0">Yes</label>
                  </li>
                  <li>
                    <input
                      id="mce-K3-1"
                      name="K3"
                      type="radio"
                      value="v2"
                    />
                    <label htmlFor="mce-K3-1">No</label>
                  </li>
                </ul>
              </div>
              <div className="clear" id="mce-responses">
                <div
                  className="response"
                  id="mce-error-response"
                  style={{ display: 'none' }}
                />
                <div
                  className="response"
                  id="mce-success-response"
                  style={{ display: 'none' }}
                />
              </div>
              {/*<!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->*/}
              <div aria-hidden="true" style={{ position: 'absolute', left: '-5000px' }}>
                <input
                  name="b_b9a5271af1d327e632c3cd503_b5691b4af5"
                  tabIndex={-1}
                  type="text"
                  value=""
                />
              </div>
              <div className="gdpr">
                <p>
                  <strong>
                    We aim to provide you with information to manage your cholesterol level that is sent straight to your inbox and is tailored to your needs.
                  </strong>{' '}
                  In order to do this, we request you to provide us with your email and also respond to the above questions (if you have not already done so).
                </p>
                <p>
                  Your email will be <strong>stored securely</strong> and{' '}
                  <strong>used only to send the weekly program</strong>{` once you have agreed to it. You can always opt
                    out of this service by following the "Unsubscribe" link at the bottom of the email. In addition, it
                    is not mandatory for you to provide us with the other information requested, but in case you do,
                    these will be coded and stored to help tailor the programme to match your needs.`}
                </p>
                <p>
                  The information we collect from you is <strong>stored in secure servers based in the US</strong>{`.
                    Our third party email provider, Mailchimp, participates in the EU-US privacy shield framework and is
                    committed to subjecting all personal data received from EU member countries to the Framework's
                    applicable principles. To learn more about the Privacy Shield Framework, visit the U.S. Department`}
                </p>
                <p>
                  <label>
                    <input
                      checked={hasConsented}
                      type="checkbox"
                      onChange={onConsentSelected}
                    />
                    <strong>
                      Please check this box to confirm that you agree to the collection, storage and processing
                      outlined above.{' '}
                    </strong>
                  </label>
                </p>
              </div>
              <div className="clear">
                <input
                  className="btn btn-primary"
                  disabled={!hasConsented}
                  id="mc-embedded-subscribe"
                  name="subscribe"
                  type="submit"
                  value="Subscribe"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

const getMenu = () => <SignupForm />;

const getPage = () => (
  <div className="navigator" style={{ display: 'inline-block' }}>
    <section className="navigator__content">
      <h1 className="navigator__title">So you have high cholesterol. What now?</h1>
      <p>
        {`Lower your cholesterol is a 12-part programme that aims to help you understand your condition and make steady and sustainable lifestyle changes to bring your cholesterol to a healthier level.
        The programme has been created with the expertise of BHF senior cardiac nurses and dietitians. Each week we'll focus on a different theme, guide you to helpful and trusted information, and suggest things you can do.`}
      </p>
      <a className="visible-xs" href="?week=sign-up#subscribe">
        <Button
          icon="open-right"
          iconLeftAligned={false}
          text={"Subscribe to BHF's programme"}
        />
      </a>

      <p>This programme aims to help you to:</p>
      <BulletedList
        items={[
          `Understand your condition and how it's treated`,
          'Understand the risks of high cholesterol and what you can do about it',
          'Make healthy lifestyle choices - and stick to them',
          'Get support when you need it',
        ]}
      />
      <br />
      <img alt="Content provided by BHF" src={`${PROGRAM_URL}bhf-content.jpg`} style={{ width: '100%' }} />
    </section>
  </div>
);

const obj = {
  getPage,
  getMenu,
  getSeoTitle: 'Living with high blood pressure | HealthUnlocked',
};

export default obj;
